module.exports = __webpack_public_path__ + "static/splash-contactus-2021-86e535f7a0c7120d8e9b17339c431970.jpg";